import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../../components/Header';
import members from '../../helpers/tempMembers';
import memberTable from '../../tables/members';
import Table from '../../components/Table';


class Home extends Component {
  render() {
    return (
      <div>
        {
          this.props.admin.data &&
  				<Header
            handleLogout={this.props.handleLogoutClick}
  					title={`Welcome, ${this.props.admin.data.name}`} />
        }
      </div>
    );
  }
}

export default connect(
  (state) => ({
    admin: state.admin
  })
)(Home);



/** WEBPACK FOOTER **
 ** ./src/containers/Home/index.js
 **/